// import { compact } from "lodash";
import { baseUrl } from "./routes/baseUrl";

export const getRetailNetworksRoute = () =>
  [`${baseUrl}`, "dict-api", "properties", "account", "search?propertyType=retail_network"].join(
    "/"
  );

export const getRoute = (port, ...dirNames) => [baseUrl, port, ...dirNames].join("/");

export const getAuthRoute = () => [`${baseUrl}`, "security-api", "oauth", "token"].join("/");

export const getActionHistory = (objectType, objectId) =>
  [baseUrl, "dict-api", "actions", `${objectType}`, `${objectId}`].join("/");

export const getProperties = (objectType, objectId) =>
  [baseUrl, "dict-api", "properties", `${objectType}`, `${objectId}`].join("/");

export const getTariffsByServiceTypeId = (serviceTypeId) =>
  `${baseUrl}/offerings-api/tariffs/search?status=active&type=common&serviceTypeId=${serviceTypeId}`;
